import { useEffect, useState } from 'react'
import { Text, Input, Select } from '@chakra-ui/react'
import DatePicker, { registerLocale } from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'
import es from 'date-fns/locale/es'

import useDistributor from '../hooks/useDistributor'
import useChannel from '../hooks/useChannel'
import useAuth from '../hooks/useAuth'

registerLocale('es', es)

const SelectWeb = ({ survey, setSurvey, setData }) => {
  const { userRegister } = useAuth()
  const { preferences } = userRegister
  const [blurDate, setBlurDate] = useState(false)
  const [blurDistributor, setBlurDistributor] = useState(false)
  // const [blurArea, setBlurArea] = useState(false)
  // const [blurBottler, setBlurBottler] = useState(false)
  const [blurChannel, setBlurChannel] = useState(false)
  // const [areas] = useArea()
  const [distributors] = useDistributor()
  // const [bottlers] = useBottler()
  const [channels] = useChannel()

  /* Checking if the datepicker is open or not. */
  useEffect(() => {
    const check = () => {
      document.addEventListener('click', () => {
        const datePicker = document.querySelector('#date-picker')

        const contains = datePicker.classList.contains(
          'react-datepicker-ignore-onclickoutside'
        )

        setBlurDate(contains)
      })
      setBlurDate(false)
    }

    check()
  })

  /* Destructuring the survey object. */
  const { date, distributor, area, bottler, channel, idDistributor, idChannel } = survey

  /* Setting the data state to the survey state. */
  useEffect(() => {
    setData({
      date,
      distributor,
      // area,
      // bottler,
      channel,
      idDistributor,
      idChannel
    })
  }, [date, distributor, area, bottler, channel])

  /**
   * The handleChange function takes in an event, and then sets the state of the survey object to the
   * value of the event target
   * @param date - the date that the user selects
   */
  const handleChangeDate = (date) => {
    setSurvey({
      ...survey,
      date
    })
  }

  /**
   * The handleChange function takes in an event, and then sets the state of the survey object to the
   * value of the event target
   * @param e - the event object
   */
  const handleChange = (e) => {
    const { name, value } = e.target

    setSurvey({
      ...survey,
      [name]: value
    })
  }

  return (
    <>
      <div className='floating-label'>
        <DatePicker
          autoComplete='off'
          className='date-picker'
          customInput={<Input />}
          dateFormat='dd/MM/yyyy'
          dateFormatCalendar='MMMM'
          id='date-picker'
          locale='es'
          maxDate={new Date()}
          placeholderText='Fecha *'
          selected={date}
          startDate={date}
          value={date}
          onChange={handleChangeDate}
        />

        {date !== '' && (
          <label className='label-select-picker'>
            {blurDate
              ? (
                <Text color={'#FF883F'}>Fecha *</Text>
              )
              : (
                <Text color={'#000'}>Fecha *</Text>
              )}
          </label>
        )}
      </div>

      <div className='floating-label'>
        <Select
          className='floating-select'
          name='distributor'
          onBlur={() => setBlurDistributor(true)}
          onChange={handleChange}
          onFocus={() => setBlurDistributor(false)}
        >
          {preferences === null
            ? <>
              <option className='option-select' value=''>
                Distribuidor *
              </option>
              {distributors
                .sort((a, b) =>
                  a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1
                )
                .map((item) => (
                  item.bottler !== null && item.geoArea !== null
                    ? item.geoArea.hasProducts === true
                      ? <option
                        key={item.distributorId}
                        value={item.description}
                        w='20px'
                      >
                        {item.description}
                      </option>
                      : null
                    : null
                ))}
            </>
            : <>
              {distributors
                .sort((a, b) =>
                  a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1
                )
                .map((item) => (
                  item.bottler !== null && item.geoArea !== null
                    ? item.geoArea.hasProducts === true
                      ? <><option key={item.distributorId} selected={preferences.distributor.description === item.description} value={item.description} w='20px'>
                        {item.description}
                      </option>
                      </>
                      : null
                    : null
                ))}
            </>
          }

        </Select>
        {distributor !== '' && (
          <label className='label-select'>
            {blurDistributor
              ? (
                <Text color={'#000'} fontWeight={400}>
                  Distribuidor *
                </Text>
              )
              : (
                <Text color={'#000'}>Distribuidor *</Text>
              )}
          </label>
        )}
      </div>
      {/*
      <div className='floating-label'>
        <Select
          className='floating-select'
          name='area'
          onBlur={() => setBlurArea(true)}
          onChange={handleChange}
          onFocus={() => setBlurArea(false)}
        >
          <option value=''>Área *</option>
          {areas
            .sort((a, b) =>
              a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1
            )
            .map((item) => (
              <option key={item.geoAreaId} value={item.description} w='20px'>
                {item.description}
              </option>
            ))}
        </Select>
        {area !== '' && (
          <label className='label-select'>
            {blurArea
              ? (
                <Text color={'#000'}>Área *</Text>
              )
              : (
                <Text color={'#FF883F'}>Área *</Text>
              )}
          </label>
        )}
      </div>

      <div className='floating-label'>
        <Select
          className='floating-select'
          name='bottler'
          onBlur={() => setBlurBottler(true)}
          onChange={handleChange}
          onFocus={() => setBlurBottler(false)}
        >
          <option value=''>Embotellador *</option>
          {bottlers
            .sort((a, b) =>
              a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1
            )
            .map((item) => (
              <option key={item.bottlerId} value={item.description} w='20px'>
                {item.description}
              </option>
            ))}
        </Select>
        {bottler !== '' && (
          <label className='label-select'>
            {blurBottler
              ? (
                <Text color={'#000'}>Embotellador *</Text>
              )
              : (
                <Text color={'#FF883F'}>Embotellador *</Text>
              )}
          </label>
        )}
      </div>
              */}

      <div className='floating-label'>
        <Select
          className='floating-select'
          name='channel'
          onBlur={() => setBlurChannel(true)}
          onChange={handleChange}
          onFocus={() => setBlurChannel(false)}
        >
          {preferences === null
            ? <>
              <option value=''>Canal *</option>
              {channels
                .sort((a, b) =>
                  a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1
                )
                .map((item) => (
                  <option key={item.channelId} value={item.description} w='20px'>
                    {item.description}
                  </option>
                ))}
            </>
            : <>
              {channels
                .sort((a, b) =>
                  a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1
                )
                .map((item) => (
                  <option key={item.channelId} selected={preferences.channel.description === item.description} value={item.description} w='20px'>
                    {item.description}
                  </option>
                ))}
            </>
          }

        </Select>
        {channel !== '' && (
          <label className='label-select'>
            {blurChannel
              ? (
                <Text
                  color={'#000'}>Canal *</Text>
              )
              : (
                <Text
                  // color={'#FF883F'}
                  color={'#000'}
                >Canal *</Text>
              )}
          </label>
        )}
      </div>
    </>
  )
}

export default SelectWeb
